import { createReducer } from 'redux-create-reducer';

import { buildHydrateEvent, HYDRATE_DUMMY } from '@AIZ-GL/hydrate-dummy';

import {
  BILLING_CITY_CHANGED,
  BILLING_STATE_CHANGED,
  BILLING_STREET_CHANGED,
  BILLING_ZIP_CHANGED,
  CREATING_STRIPE_CUSTOMER,
  CREDIT_CARD_CVC_CHANGED,
  CREDIT_CARD_EXP_CHANGED,
  CREDIT_CARD_NUMBER_CHANGED,
  PRICES_FETCHED,
  PRICES_FETCHED_ERRORED,
  PRICES_FETCHING,
  STRIPE_CUSTOMER_CREATED,
  STRIPE_CUSTOMER_CREATE_FAILURE,
  STRIPE_TOKEN_FETCHING,
  STRIPE_TOKEN_FETCHED,
  STRIPE_TOKEN_FETCHED_ERROR,
  USE_REPAIR_ADDRESS_FOR_BILLING,
} from '../actions';
import determineCardType from '../utils/credit-cards';

const initialState = {
  cardType: '',
  billingCity: '',
  billingStreetAddress: '',
  billingState: '',
  billingZip: '',
  cvc: '',
  discountAmountInCents: 0,
  discountPercentage: 0,
  error: '',
  exp: '',
  number: '',
  lastFour: '',
  loading: false,
  tokenId: '',
  userId: '',
};

const dummyData = {
  billingCity: 'Baltimore',
  billingStreetAddress: '1407 Fleet Street',
  billingState: 'MD',
  billingZip: '21231',
  cvc: '123',
  exp: '12 / 2022',
  number: '4242424242424242',
};

const events = {
  [HYDRATE_DUMMY]: buildHydrateEvent(dummyData),

  [BILLING_STREET_CHANGED]: (state, { billingStreetAddress }) => ({
    ...state,
    billingStreetAddress,
  }),

  [BILLING_CITY_CHANGED]: (state, { billingCity }) => ({
    ...state,
    billingCity,
  }),

  [BILLING_STATE_CHANGED]: (state, { billingState }) => ({
    ...state,
    billingState,
  }),

  [BILLING_ZIP_CHANGED]: (state, { billingZip }) => ({ ...state, billingZip }),

  [CREATING_STRIPE_CUSTOMER]: state => {
    return { ...state, loading: true, error: '' };
  },

  [CREDIT_CARD_CVC_CHANGED]: (state, { cvc }) => {
    return { ...state, cvc };
  },

  [CREDIT_CARD_EXP_CHANGED]: (state, { exp }) => {
    return { ...state, exp };
  },

  [CREDIT_CARD_NUMBER_CHANGED]: (state, { number }) => {
    const cardType = determineCardType(number);

    return { ...state, number, cardType };
  },

  [PRICES_FETCHED_ERRORED]: () => {
    return initialState;
  },

  [PRICES_FETCHING]: state => {
    return { ...state, loading: true };
  },

  [PRICES_FETCHED]: state => ({
    ...state,
    loading: false,
  }),

  [STRIPE_CUSTOMER_CREATE_FAILURE]: (state, { error = '' }) => {
    return { ...state, loading: false, error };
  },

  [STRIPE_CUSTOMER_CREATED]: (state, { lastFour, userId }) => {
    return {
      ...state,
      cvc: '',
      exp: '',
      number: '',
      loading: false,
      lastFour,
      userId,
    };
  },

  [STRIPE_TOKEN_FETCHING]: state => ({
    ...state,
    loading: true,
  }),

  [STRIPE_TOKEN_FETCHED]: (state, { id }) => {
    return {
      ...state,
      loading: false,
      tokenId: id,
    };
  },

  [STRIPE_TOKEN_FETCHED_ERROR]: (state, { error = '' }) => ({
    ...state,
    loading: false,
    error,
  }),

  [USE_REPAIR_ADDRESS_FOR_BILLING]: (state, { addressComponents }) => {
    const {
      city = '',
      state: addressState = '',
      streetAddress = '',
      zipCode = '',
    } = addressComponents;

    return {
      ...state,
      billingCity: city,
      billingStreetAddress: streetAddress,
      billingState: addressState,
      billingZip: zipCode,
    };
  },
};

export default createReducer(initialState, events);
